import React, { useCallback } from 'react';
export const useTrace = (tracePrefix) => (suffix) => ({
    'automation-id': `${tracePrefix}${suffix ? `-${suffix}` : ''}`.replace(/\s/g, ''),
});
export const getTrace = useTrace;
export function withTrace(defaultPrefix) {
    return (WrappedComponent) => {
        const tracedComponent = function TracedComponent(props) {
            const { 'automation-id': automationId = defaultPrefix } = props;
            const applyTraceFunc = useCallback(useTrace(automationId), [automationId]);
            return (React.createElement(WrappedComponent, Object.assign({ applyTrace: applyTraceFunc, "automation-id": automationId }, props)));
        };
        return tracedComponent;
    };
}
//# sourceMappingURL=trace.js.map